'use client';

import { Typography } from '@curology/ui-components-web/react/Typography';
import Image from 'next/image';
import React from 'react';

import { useDataProvider } from '@/components/flow/components/DataProvider/useDataProvider';
import { DATA_KEYS } from '@/consts/dataKeys';

export const HairPromoCard = () => {
  const promotion = useDataProvider(DATA_KEYS.promotion);

  if (!promotion?.id) {
    return null;
  }

  // These text values can be easily be swapped out to pull from the
  // LD config via an Atom once we have the Pricing test configured.
  const primaryText = promotion.titleText;
  const secondaryText = promotion.altText;

  return (
    <div className="cur-flex cur-justify-between cur-bg-[#dad4c4]">
      <div className="cur-flex cur-items-center cur-justify-center cur-p-4">
        <div>
          <Typography size="body" weight="bold" className="cur-text-brand">
            {primaryText}
          </Typography>
          <Typography
            size="meta"
            dangerouslySetInnerHTML={{ __html: secondaryText }}
          ></Typography>
        </div>
      </div>
      <div className="cur-h-auto cur-max-w-[105px] cur-min-w-[105px]">
        <Image
          alt="Hands holding open bottle of hair formula with dropper inserted"
          height={202}
          src="https://images.ctfassets.net/8pzh4g8cs30t/5nv97kOsc5duXK7Lhwpa3u/84030fb7567f6890ea7e4c4643587253/hair-formula-rx.png"
          style={{
            height: 'auto',
            maxWidth: '100%',
          }}
          width={210}
        />
      </div>
    </div>
  );
};
